import { RiskFactorInfo } from '../../models/risk-factor/risk-factor-info';

/**
 * リクエスト
 */
export class PlanByTravelWLRequest {
	public transactionDate: string = null; // トランザクション日時
	public riskFactorInfo: RiskFactorInfo = null; // リスクファクタ情報
}